import orderonlineApi from '@/api/orderonline';

const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE';
const SET_SEARCH_CATEGORY = 'SET_SEARCH_CATEGORY';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_PRODUCT_ADDED = 'SET_PRODUCT_ADDED';
const SET_IS_DUPLICATING_FUNNEL = 'SET_IS_DUPLICATING_FUNNEL';

const state = {
	searchQuery: '',
	searchType: 'product',
	searchCategory: 'all',
	isFetching: false,
	isDuplicatingFunnel: false,
	isFetched: false,
	productAdded: [],
};

const getters = {
	searchQuery: state => state.searchQuery,
	searchType: state => state.searchType,
	searchCategory: state => state.searchCategory,
	productAdded: state => state.productAdded,
	isFetching: state => state.isFetching,
};

const mutations = {
	[SET_SEARCH_QUERY](state, query) {
		state.searchQuery = query;
	},
	[SET_SEARCH_TYPE](state, type) {
		state.searchType = type;
	},
	[SET_SEARCH_CATEGORY](state, category) {
		state.searchCategory = category;
	},
	[SET_PRODUCT_ADDED](state, products) {
		state.productAdded = products;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_DUPLICATING_FUNNEL](state, status) {
		state.isDuplicatingFunnel = status;
	},
};

const actions = {
	setSearchQuery({ commit }, query) {
		commit(SET_SEARCH_QUERY, query);
	},
	setSearchType({ commit }, type) {
		commit(SET_SEARCH_TYPE, type);
	},
	setSearchCategory({ commit }, category) {
		commit(SET_SEARCH_CATEGORY, category);
	},
	appendProductAdded({ commit, state }, newProduct) {
		const products = [
			...state.productAdded,
			newProduct,
		];
		commit(SET_PRODUCT_ADDED, products);
	},
	getDropshipProductAdded({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const products = response.data || [];
				if (products.length !== 0) {
					commit(SET_PRODUCT_ADDED, products);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			orderonlineApi.getAddedDropshipProducts(params, callback, errorCallback);
		}
	},
	funnelDuplicate({ commit }, params) {
		commit(SET_IS_DUPLICATING_FUNNEL, true);

		const reqParams = {};
		if (params._id) {
			reqParams.oo_product_id = params._id;
		}
		if (params.source_id) {
			reqParams.product_id = params.source_id;
		}

		const callback = () => {
			commit(SET_IS_DUPLICATING_FUNNEL, false);
		};

		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_DUPLICATING_FUNNEL, false);
		};

		orderonlineApi.duplicateFunnel(reqParams, callback, errorCallback);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
